var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"site-footer"},[_c('div',{staticClass:"footer-content"},[_vm._m(0),_c('div',{staticClass:"footer-contact"},[_c('p',[_vm._v(" "+_vm._s(_vm.address)+" ")]),_c('p',[_vm._v(" "+_vm._s(_vm.phone)+" ")])])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer-info"},[_c('p',[_vm._v(" Cabinet de Psihologie Presecan "),_c('br'),_vm._v(" Alba Iulia ")])])
}]

export { render, staticRenderFns }